import { routes as queueRoutes } from "./queue/routes";
import { routes as medicalFileRoutes } from "./medical-file/routes";
import { routes as triageRoutes } from "./triage/routes";
import { routes as printsRoutes } from "./prints/routes";

export const routes = [

    ...queueRoutes(`outpatient`),
    ...medicalFileRoutes(`outpatient`),
    ...triageRoutes(`outpatient`),
    ...printsRoutes(`outpatient`),
];
